<template>
  <v-dialog v-model="show" width="500">
    <v-card>
      <v-card-title> Contaminación de preservadas cepario </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col>
              <span> Preservadas a desechar {{ preserved.length }} </span>
            </v-col>
            <v-col cols="12">
              <v-simple-table height="400px">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">ID tubo/caja</th>
                      <th class="text-left">Fecha de preservación</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in preserved" :key="index">
                      <td>{{ item.identifier }}</td>
                      <td>{{ item.realDatePreservation }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-container>
          <v-row>
            <v-col cols="12" xl="6" lg="6" md="6">
              <v-btn color="gray" dark @click="show = false" block>
                Cancelar
              </v-btn>
            </v-col>
            <v-col cols="12" xl="6" lg="6" md="6">
              <v-btn color="primary" @click="apply" block> Aplicar </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    observations: null,
  }),
  props: {
    value: Boolean,
    preserved: Array,
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    apply() {
      this.$emit("confirmation");
      this.show = false;
    },
  },
};
</script>
